import { getRouterSelectors } from '@ngrx/router-store';

export const {
  selectQueryParam,
  selectRouteParam,
  selectRouteDataParam,
  selectCurrentRoute,
} = getRouterSelectors();
